<template>
  <div>
    <ts-dialog title="Add a working file" :visible.sync="visible" width="850px" center :show-close="false">
      <ts-form-item label="Type of content" :offset="18" class="form-item">
        <ts-select v-model="selectedAssetTypeId">
          <el-option
            v-for="assetType in assetTypes"
            :key="assetType.id"
            :label="assetType.name"
            :value="assetType.id"
          ></el-option>
        </ts-select>
      </ts-form-item>
      <div v-show="selectedAssetTypeId === 'google-drive-link'" class="horizontal-form">
        <ts-form-item label="File name" :validation="$v.form.googleDriveLinkFileName" class="form-item">
          <ts-input v-model="$v.form.googleDriveLinkFileName.$model"></ts-input>
        </ts-form-item>
        <ts-form-item label="URL" :validation="$v.form.googleDriveLinkUrl" class="form-item">
          <ts-input placeholder="https://" v-model="$v.form.googleDriveLinkUrl.$model"></ts-input>
        </ts-form-item>
      </div>
      <div v-show="selectedAssetTypeId === 'uploaded-file'" class="horizontal-form">
        <ts-form-item label="File" :validation="$v.form.uploadedFile" :offset="18" class="form-item">
          <ts-button ref="upload" :style="{ width: '100%' }"> Select file </ts-button>
        </ts-form-item>
        <ts-form-item label="File name" :validation="$v.form.uploadedFileName" class="form-item">
          <ts-input v-model="$v.form.uploadedFileName.$model"></ts-input>
        </ts-form-item>
      </div>
      <span slot="footer">
        <div class="footer">
          <ts-button @click="handleUploadClick">Upload</ts-button>
        </div>
      </span>
    </ts-dialog>
    <ts-button size="small" @click="handleOpenPickerButtonClick" style="display: none"> Add files </ts-button>
  </div>
</template>

<style lang="scss" scoped>
.form-item {
  margin: 12px 0 12px 12px;
}

.horizontal-form {
  display: flex;

  > * {
    margin-right: 12px;
  }
}
</style>

<script>
import { requiredIf, url } from 'vuelidate/lib/validators';

import projectViewHelpers from '@/mixins/projectViewHelpers';

export default {
  mixins: [projectViewHelpers],
  components: {},
  props: {
    resumable: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      visible: false,
      initialized: false,
      selectedAssetTypeId: 'google-drive-link',
      assetTypes: [
        {
          id: 'google-drive-link',
          name: 'Google Drive'
        },
        {
          id: 'uploaded-file',
          name: 'File'
        }
      ],
      form: {
        googleDriveLinkFileName: '',
        googleDriveLinkUrl: '',
        uploadedFile: null,
        uploadedFileName: ''
      }
    };
  },
  validations: {
    form: {
      googleDriveLinkFileName: {
        required: requiredIf(function () {
          return this.selectedAssetTypeId === 'google-drive-link';
        })
      },
      googleDriveLinkUrl: {
        required: requiredIf(function () {
          return this.selectedAssetTypeId === 'google-drive-link';
        }),
        url
      },
      uploadedFile: {
        required: requiredIf(function () {
          return this.selectedAssetTypeId === 'uploaded-file';
        })
      },
      uploadedFileName: {
        required: requiredIf(function () {
          return this.selectedAssetTypeId === 'uploaded-file';
        })
      }
    }
  },
  methods: {
    resetForm() {
      for (const file of this.resumable.files) {
        this.resumable.removeFile(file);
      }

      this.form = {
        googleDriveLinkFileName: '',
        googleDriveLinkUrl: '',
        uploadedFile: null,
        uploadedFileName: ''
      };
      this.$v.$reset();
    },
    handleOpenPickerButtonClick() {
      this.visible = true;
      this.resetForm();
      if (!this.initialized) {
        this.$nextTick(() => {
          this.resumable.assignBrowse(this.$refs.upload.$el);
          this.resumable.on('fileAdded', file => {
            this.$v.form.uploadedFile.$model = file;
            this.$v.form.uploadedFileName.$model = file.fileName;
          });
          this.initialized = true;
        });
      }
    },
    handleUploadClick() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        if (this.selectedAssetTypeId === 'google-drive-link') {
          this.$emit('input', {
            name: this.form.googleDriveLinkFileName,
            url: this.form.googleDriveLinkUrl,
            type: 'google-drive-link'
          });
        }
        if (this.selectedAssetTypeId === 'uploaded-file') {
          this.$emit('input', {
            name: this.form.uploadedFileName,
            resumableFile: this.form.uploadedFile,
            type: 'uploaded-file'
          });
        }
        this.visible = false;
      }
    }
  }
};
</script>
